import { render, staticRenderFns } from "./heavy-and-oversized-cargo.vue?vue&type=template&id=54d684ae&"
import script from "./heavy-and-oversized-cargo.vue?vue&type=script&lang=js&"
export * from "./heavy-and-oversized-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports